import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import conciergeApiClient from "Services/Apis/Concierge/conciergeApiClient";

export const approveQuotationWithTermThunk = createAsyncThunk(
  "ApproveQuotationWithTermSlice/approveQuotationWithTermThunk",
  async (approval, { getState, rejectWithValue }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const config = { headers };

    const { solicitationId, fileUrl, note } = approval;

    const body = {
      solicitationId,
      fileUrl,
      note,
    };

    const reqUrl = `/Redemption/${solicitationId}/approve-with-term`;

    try {
      const { data } = await conciergeApiClient.post(reqUrl, body, config);
      return data;
    }
    catch (error) {
      const payload = {
        responseData: error.response?.data,
        requestData: {
          url: reqUrl,
          headers,
          body,
        }
      }

      return rejectWithValue(payload);
    }
  }
);

const initialState = {
  approvalWithTermData: null,
  isApprovalWithTermLoading: false,
  approvalWithTermHasError: false,
  errorsApprovalWithTerm: null
};

const approveQuotationWithTermSlice = createSlice({
  name: "ApproveQuotationWithTerm",
  initialState,
  reducers: {
    resetApproveSolicitationWithTermData: (state) => {
      state.approvalWithTermData = null;
      state.isApprovalWithTermLoading = false;
      state.approvalWithTermHasError = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(approveQuotationWithTermThunk.pending, (state) => {
      state.approvalWithTermData = null;
      state.isApprovalWithTermLoading = true;
      state.approvalWithTermHasError = false;
    });

    builder.addCase(approveQuotationWithTermThunk.fulfilled, (state, action) => {
      state.approvalWithTermData = action.payload;
      state.isApprovalWithTermLoading = false;
      state.approvalWithTermHasError = false;
    });

    builder.addCase(approveQuotationWithTermThunk.rejected, (state, action) => {
      state.approvalWithTermData = null;
      state.isApprovalWithTermLoading = false;
      state.approvalWithTermHasError = true;
      state.errorsApprovalWithTerm = action.payload;
    });
  },
});

export const { resetApproveSolicitationWithTermData } = approveQuotationWithTermSlice.actions;

export default approveQuotationWithTermSlice.reducer;